/** @format */

import { Component, OnInit, EventEmitter, Output, ViewChild, Input, ElementRef, OnChanges, TemplateRef, ChangeDetectorRef, SimpleChange, SimpleChanges, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import {
	Search,
	MenuItem,
	SearchResultsPayload,
	SearchResultsSuccess,
	ApplicationAction,
	ProblemType,
	SelectedProblemSubType,
	SaveSearchQueryPayload,
	SearchQuery,
	ProblemStatus,
	ProblemSource,
	Group,
	User,
	ContactType,
	Role,
	ProblemPriority,
	ProblemReceived,
	Assignee,
} from 'src/app/state-management';
import { NgbInputDatepicker, NgbCalendar, NgbDateParserFormatter, NgbDate, NgbDateStruct, NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Params } from '@angular/router';
import { queryParameterNames, SearchProblem } from 'src/app/state-management';
import { DnvMapAction, DnvMapState } from 'dnv-lib';
import { ProblemContact } from 'src/app/models/problem';
declare var $: any;

@Component({
	selector: 'app-search-form',
	templateUrl: './search-form.component.html',
	styleUrls: ['./search-form.component.css'],
	standalone: false,
	changeDetection: ChangeDetectionStrategy.Default,
})
export class SearchFormComponent implements OnInit, OnChanges {
	@Output() searchEmitter = new EventEmitter<SearchResultsPayload>();
	@Output() actionEmitter = new EventEmitter<ApplicationAction>();
	@Output() saveSearchEmitter = new EventEmitter<SaveSearchQueryPayload>();
	@Output() mapUpdateEmitter = new EventEmitter<DnvMapAction>();
	@Output() mapZoomEmitter = new EventEmitter<DnvMapState>();
	@Output() mapMoveEmitter = new EventEmitter<DnvMapState>();
	@Output() clearDrawingEmitter = new EventEmitter();
	@Output() startDrawingEmitter = new EventEmitter();
	@Output() setPinEmitter = new EventEmitter();
	@Input() mapState: DnvMapState;
	@Input() menuItem: MenuItem;
	@Input() searchResults: SearchProblem[];
	@Input() searching: boolean;
	@Input() problemNo: string;
	@Input() noPin: boolean;
	uniqueKey: any;
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('searchParams') set searchParams(queryParams: Params) {
		if (queryParams) {
			// This should be improved, it is to give the menuItem query time to return before trying to set the dropdowns
			setTimeout(() => {
				this.updateSearchFormGroup(queryParams);
			}, 2000);
		}
	}
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('searchQueryParams') set searchQueryParams(searchQueryParams: Params) {
		if (searchQueryParams) {
			this.updateSearchFormGroup(searchQueryParams);
		}
	}

	@ViewChild('saveSearchModal') saveSearchModal: TemplateRef<any>;

	modal: NgbModalRef = null;
	searchFormGroup: UntypedFormGroup;
	hoveredDateReport: NgbDate;
	reportDateStart: NgbDate = null;
	reportDateEnd: NgbDate = null;
	completeDateStart: NgbDate;
	completeDateEnd: NgbDate;
	hoveredDateComplete: NgbDate;
	reportDatesValid = true;
	completeDatesValid = true;
	unassignedAssignee = {
		user_Id: -1,
		firstName: 'Unassigned',
		lastName: '',
		email: '',
		employee_No: 0,
		department_RefId: 0,
	};
	polygon: string;
	mapShow = false;
	buttonName = 'Show';
	saveSearchName = '';
	clearSearchFormEvent = 'clearSearchFormEvent';
	clickSearchPointMarkerEvent = 'clickSearchMapProblemEvent';
	clickedMarkerNumber = '';
	searchFormPopulated = false;
	shouldOpenDeleteQueryPrompt = false;
	validSearchParams = true;
	assignees: Assignee[];

	queryParameterNamesToFormGroupMap = {
		caseNumber: 'caseNumber',
		description: 'description',
		typeId: 'problemType',
		subTypeId: 'problemSubType',
		statusId: 'problemStatus',
		sourceId: 'problemSource',
		receivedFromId: 'problemReceivedFrom',
		groupId: 'group',
		assigneeId: 'assignee',
		contactId: 'contactType',
		roleId: 'assignee', // TODO check mapping on this
		reportedDateBegin: 'reportDateStart',
		reportedDateEnd: 'reportDateEnd',
		completedDateBegin: 'completeDateStart',
		completedDateEnd: 'completeDateEnd',
		location: 'location',
		firstName: 'firstName',
		lastName: 'lastName',
		address: 'address',
		phone: 'phone',
		email: 'email',
		polygon: 'polygon',
		priorityId: 'priority',
		workOrderNumber: 'workOrderNumber',
	};

	saveSearchForm = new UntypedFormGroup({
		saveSearchName: new UntypedFormControl(''),
	});

	constructor(element: ElementRef, private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, private modalService: NgbModal, private changeDetector: ChangeDetectorRef) {
		document.addEventListener(this.clearSearchFormEvent, () => this.clearSearchResults());
		this.searchFormGroup = new UntypedFormGroup({
			caseNumber: new UntypedFormControl(null),
			description: new UntypedFormControl(null),
			problemType: new UntypedFormControl(null),
			problemSubType: new UntypedFormControl(null),
			problemSource: new UntypedFormControl(null),
			problemStatus: new UntypedFormControl(null),
			group: new UntypedFormControl(null),
			completeDateStart: new UntypedFormControl(null),
			completeDateEnd: new UntypedFormControl(null),
			reportDateStart: new UntypedFormControl(null),
			reportDateEnd: new UntypedFormControl(null),
			assignee: new UntypedFormControl(null),
			contactType: new UntypedFormControl(null),
			location: new UntypedFormControl(null),
			firstName: new UntypedFormControl(null),
			lastName: new UntypedFormControl(null),
			phone: new UntypedFormControl(null),
			email: new UntypedFormControl(null),
			address: new UntypedFormControl(null),
			priority: new UntypedFormControl(null),
			workOrderNumber: new UntypedFormControl(null),
			problemReceivedFrom: new UntypedFormControl(null),
		});

		window.addEventListener(this.clickSearchPointMarkerEvent, (e: any) => {
			if (this.clickedMarkerNumber !== e.detail) {
				this.clickedMarkerNumber = e.detail;

				// this is a RAP problem number
				if (this.clickedMarkerNumber.indexOf('PRB') === 0 || this.clickedMarkerNumber.indexOf('RFS') === 0) {
					const url = `${window.location.origin}/problemdetails?ProblemNo=${this.clickedMarkerNumber}`;
					window.open(url, '_blank');
					setTimeout(() => (this.clickedMarkerNumber = ''), 1000);
				}
			}
		});
	}

	checkFieldsPopulated() {

		const formValues = this.searchFormGroup.getRawValue();

		// get number of null or empty values
		const nullCount = Object.values(formValues).filter(value => value === null || value === "").length;

		// total number of inputtable fields for the search criteria
		const numTotalSearchFields = Object.keys(this.searchFormGroup.controls).length;
		this.searchFormPopulated = nullCount < numTotalSearchFields ? true : false;
	}

	updateSearchFormGroup(queryParams: Params) {
		const dateRegex = /(\d\d\d\d)-(\d\d)-(\d\d)/;
		const today = new Date();
		let ngbDate: NgbDate;
		let triggerSearch = false;

		queryParameterNames.forEach((field) => {
			if (dateRegex.test(queryParams[field])) {
				const match = dateRegex.exec(queryParams[field]);
				ngbDate = new NgbDate(Number(match[1]), Number(match[2]), Number(match[3]));
				triggerSearch = true;
			} else {
				ngbDate = new NgbDate(today.getFullYear(), today.getMonth(), today.getDate());
			}

			if (queryParams[field]) {
				switch (field) {
					case 'caseNumber':
					case 'description':
					case 'location':
					case 'firstName':
					case 'lastName':
					case 'address':
					case 'phone':
					case 'email':
						this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(queryParams[field]);
						triggerSearch = triggerSearch || (queryParams[field] as string).length > 0;
						break;
					case 'typeId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const types: string[] = queryParams[field].split(',');
							const problemTypes: ProblemType[] = [];

							types.forEach((type) => {
								const typeId = this.menuItem.allProblemTypeList.findIndex((pl) => pl.problemType_Id === Number(type));
								problemTypes.push(this.menuItem.allProblemTypeList[typeId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemTypes);
							triggerSearch = true;
						}
						break;
					case 'subTypeId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const subtypes: string[] = queryParams[field].split(',');
							const problemSubTypes: SelectedProblemSubType[] = [];

							subtypes.forEach((subtype) => {
								const subtypeId = this.menuItem.allProblemSubTypeList.findIndex((psl) => psl.problemSubType_Id === Number(subtype));

								if (subtype === '99999') {
									problemSubTypes.push({
										problemSubType_Id: 99999,
										problemSubType_Name: 'Blank',
										description: '',
										active: true,
										problemType_RefId: 894,
									});
								} else {
									problemSubTypes.push(this.menuItem.allProblemSubTypeList[subtypeId]);
								}
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemSubTypes);
							triggerSearch = true;
						}
						break;
					case 'statusId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const statuses: string[] = queryParams[field].split(',');
							const problemStatuses: ProblemStatus[] = [];

							statuses.forEach((status) => {
								const statusId = this.menuItem.problemStatusList.findIndex((psl) => psl.problemStatus_Id === Number(status));
								problemStatuses.push(this.menuItem.problemStatusList[statusId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemStatuses);
							triggerSearch = true;
						}
						break;
					case 'sourceId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const sources: string[] = queryParams[field].split(',');
							const problemSources: ProblemSource[] = [];

							sources.forEach((source) => {
								const problemSourceId = this.menuItem.problemSourceList.findIndex((sl) => sl.problemSource_Id === Number(source));
								problemSources.push(this.menuItem.problemSourceList[problemSourceId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemSources);
							triggerSearch = true;
						}
						break;
					case 'receivedFromId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const receivedFromSelections: string[] = queryParams[field].split(',');
							const receivedFromSources: ProblemReceived[] = [];

							receivedFromSelections.forEach((rf) => {
								const receivedFromSourceIndex = this.menuItem.problemReceivedFromList.findIndex(
									(rfs) => rfs.problemReceivedFrom_Id === Number(rf)
								);
								receivedFromSources.push(this.menuItem.problemReceivedFromList[receivedFromSourceIndex]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(receivedFromSources);
							triggerSearch = true;
						}
						break;
					case 'groupId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const groups: string[] = queryParams[field].split(',');
							const problemGroups: Group[] = [];

							groups.forEach((group) => {
								const groupId = this.menuItem.problemGroupList.findIndex((gl) => gl.group_Id === Number(group));
								problemGroups.push(this.menuItem.problemGroupList[groupId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemGroups);
							triggerSearch = true;
						}
						break;
					case 'assigneeId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const assignees: string[] = queryParams[field].split(',');
							const allUsers: User[] = [];

							assignees.forEach((assignee) => {
								const assigneeId = this.menuItem.allUsersList.findIndex((u) => u.user_Id === Number(assignee));
								allUsers.push(this.menuItem.allUsersList[assigneeId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(allUsers);
							triggerSearch = true;
						}
						break;
					case 'contactId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const contacts: string[] = queryParams[field].split(',');
							const contactTypes: ContactType[] = [];

							contacts.forEach((contact) => {
								const contactId = this.menuItem.contactTypes.findIndex((ct) => ct.contactType_Id === Number(contact));
								contactTypes.push(this.menuItem.contactTypes[contactId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(contactTypes);
							triggerSearch = true;
						}
						break;
					case 'roleId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const roles: string[] = queryParams[field].split(',');
							const problemRoles: Role[] = [...this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).value];

							roles.forEach((role) => {
								const roleId = this.menuItem.problemRoleList.findIndex((rl) => rl.role_Id === Number(role));
								problemRoles.push(this.menuItem.problemRoleList[roleId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemRoles);
							triggerSearch = true;
						}
						break;
					case 'reportedDateBegin':
						this.reportDateStart = ngbDate;
						this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(ngbDate);
						triggerSearch = true;
						break;
					case 'reportedDateEnd':
						this.reportDateEnd = ngbDate;
						this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(ngbDate);
						triggerSearch = true;
						break;
					case 'completedDateBegin':
						this.completeDateStart = ngbDate;
						this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(ngbDate);
						triggerSearch = true;
						break;
					case 'completedDateEnd':
						this.completeDateEnd = ngbDate;
						this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(ngbDate);
						triggerSearch = true;
						break;
					case 'priorityId':
						if (queryParams[field].length > 0 && queryParams[field] !== '0') {
							const priorities: string[] = queryParams[field].split(',');
							const problemPriorities: ProblemPriority[] = [];

							priorities.forEach((priority) => {
								const priorityId = this.menuItem.problemPriorityList.findIndex((p) => p.problemPriority_Id === Number(priority));
								problemPriorities.push(this.menuItem.problemPriorityList[priorityId]);
							});

							this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(problemPriorities);
							triggerSearch = true;
						}
						break;
					case 'workOrderNumber':
						this.searchFormGroup.get(this.queryParameterNamesToFormGroupMap[field]).setValue(queryParams[field]);
						triggerSearch = triggerSearch || (queryParams[field] as string).length > 0;
						break;
					default:
						break;
				}
			}
		});

		if (triggerSearch && this.searchResults.length === 0) {
			this.searchFormPopulated = true;
			this.onSubmitSearch();
		}
	}

	ngOnInit() {
		// console.log(this.menuItem);
		//  this.searchFormGroup.setValidators(this.atLeastOneValidator());

		// RAP-1034 'save' button should only be enabled after user has clicked search
		// const formElements = document.getElementsByClassName('form-control');
		// Array.from(formElements).forEach((formElement) => {
		// 	if (formElement.id !== 'saveSearchNameInput') {
		// 		formElement.addEventListener('change', this.checkFieldsPopulated.bind(this));
		// 	}
		// });

		if (this.problemNo && this.problemNo.length > 0) {
			this.toggleMap();
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.menuItem) {
			if (changes.menuItem?.currentValue?.allUsersList?.length > 0) {
				const allUsers = this.menuItem.allUsersList.map((usr: User) => {
					return {
						user_Id: usr.user_Id,
						name: usr.firstName + ' ' + usr.lastName,
						email: usr.email,
						employee_No: usr.employee_No,
						group_RefId: usr.group_RefId,
						active: usr.active,
						upn: usr.upn,
						edocsAlias: usr.edocsAlias,
						type: 'Users'
					}
				})
				allUsers.push({
					user_Id: this.unassignedAssignee.user_Id,
					name: this.unassignedAssignee.firstName + ' ' + this.unassignedAssignee.lastName,
					email: this.unassignedAssignee.email,
					employee_No: this.unassignedAssignee.employee_No,
					group_RefId: 0,
					active: true,
					upn: '',
					edocsAlias: '',
					type: 'Users'
				});
				const roles = this.menuItem.problemRoleList.map((role) => {
					return {
						role_Id: role.role_Id,
						group_RefId: role.group_RefId,
						name: role.name,
						email: role.email,
						active: role.active,
						group: role.group,
						type: 'Roles'
					}
				})
				this.assignees = [
					...roles,
					...allUsers
				]
			}

		}

		if(changes.noPin){
			console.log(changes.noPin)
		}

	}

	stringifySelectMembers(source: string, id: string) {
		let concatenatedString = '';

		if (this.searchFormGroup.get(source).value) {
			Array.from(this.searchFormGroup.get(source).value).forEach((element: any) => {
				if (element && element[id] !== undefined) {
					concatenatedString += `${element[id]},`;
				}
			});
		}

		return concatenatedString === '' ? '0' : concatenatedString.slice(0, concatenatedString.length - 1);
	}

	createSearchParams() {
		const searchParams: SearchResultsPayload = {
			caseNumber: (this.searchFormGroup.get('caseNumber').value ? this.searchFormGroup.get('caseNumber').value : '').trim(),
			description: (this.searchFormGroup.get('description').value ? this.searchFormGroup.get('description').value : '').trim(),
			sourceId: this.stringifySelectMembers('problemSource', 'problemSource_Id'),
			receivedFromId: this.stringifySelectMembers('problemReceivedFrom', 'problemReceivedFrom_Id'),
			groupId: this.stringifySelectMembers('group', 'group_Id'),
			statusId: this.stringifySelectMembers('problemStatus', 'problemStatus_Id'),
			typeId: this.stringifySelectMembers('problemType', 'problemType_Id'),
			subTypeId: this.stringifySelectMembers('problemSubType', 'problemSubType_Id'),
			reportedDateBegin: this.searchFormGroup.get('reportDateStart').value
				? formatDate(
					new Date(
						this.searchFormGroup.get('reportDateStart').value.year,
						this.searchFormGroup.get('reportDateStart').value.month - 1,
						this.searchFormGroup.get('reportDateStart').value.day
					),
					'yyyy-MM-dd',
					'en-US'
				)
				: '',

			reportedDateEnd: this.searchFormGroup.get('reportDateEnd').value
				? formatDate(
					new Date(
						this.searchFormGroup.get('reportDateEnd').value.year,
						this.searchFormGroup.get('reportDateEnd').value.month - 1,
						this.searchFormGroup.get('reportDateEnd').value.day
					),
					'yyyy-MM-dd',
					'en-US'
				)
				: '',

			completedDateBegin: this.searchFormGroup.get('completeDateStart').value
				? formatDate(
					new Date(
						this.searchFormGroup.get('completeDateStart').value.year,
						this.searchFormGroup.get('completeDateStart').value.month - 1,
						this.searchFormGroup.get('completeDateStart').value.day
					),
					'yyyy-MM-dd',
					'en-US'
				)
				: '',

			completedDateEnd: this.searchFormGroup.get('completeDateEnd').value
				? formatDate(
					new Date(
						this.searchFormGroup.get('completeDateEnd').value.year,
						this.searchFormGroup.get('completeDateEnd').value.month - 1,
						this.searchFormGroup.get('completeDateEnd').value.day
					),
					'yyyy-MM-dd',
					'en-US'
				)
				: '',

			assigneeId: this.stringifySelectMembers('assignee', 'user_Id'),
			contactId: this.stringifySelectMembers('contactType', 'contactType_Id'),
			roleId: this.stringifySelectMembers('assignee', 'role_Id'),
			location: (this.searchFormGroup.get('location').value ? this.searchFormGroup.get('location').value : '').trim(),
			firstName: (this.searchFormGroup.get('firstName').value ? this.searchFormGroup.get('firstName').value : '').trim(),
			lastName: (this.searchFormGroup.get('lastName').value ? this.searchFormGroup.get('lastName').value : '').trim(),
			address: (this.searchFormGroup.get('address').value ? this.searchFormGroup.get('address').value : '').trim(),
			phone: (this.searchFormGroup.get('phone').value ? this.searchFormGroup.get('phone').value : '').trim(),
			email: (this.searchFormGroup.get('email').value ? this.searchFormGroup.get('email').value : '').trim(),
			polygon: [[0, 0]],
			workOrderNumber: (this.searchFormGroup.get('workOrderNumber').value ? this.searchFormGroup.get('workOrderNumber').value : '').trim(),
			priorityId: this.stringifySelectMembers('priority', 'problemPriority_Id'),
		};

		return searchParams;
	}

	onSubmitSearch() {
		if (this.searchFormGroup.valid) {
			const searchParams = this.createSearchParams();
			if (this.checkNotEmptyOrZero(searchParams)) {
				this.checkFieldsPopulated();
				this.validSearchParams = true;
				this.searchEmitter.emit(searchParams);
			} else {
				this.validSearchParams = false;
			}
		}
	}

	change(el: HTMLOrSVGElement, dael: NgbInputDatepicker) {
		dael.open();
		setTimeout(function () {
			el.focus();
		}, 500);
	}

	// atLeastOneValidator = () => {
	//   return (controlGroup: FormGroup) => {
	//     const controls = controlGroup.controls;
	//     if (controls) {
	//       const theOne = Object.keys(controls).find(key => controls[key].value !== null);
	//       if (!theOne) {
	//         return {
	//           atLeastOneRequired: {
	//             text: 'Please enter at least one field'
	//           }
	//         };
	//       }
	//     }
	//     return null;
	//   };
	// }

	isNumberKey(event: any) {
		let value = event.key;
		var regex = /^[0-9]+$/;
		return regex.test(value);
	}

	clearSearchResults() {
		this.actionEmitter.emit(new SearchResultsSuccess([] as SearchResultsPayload));
		this.clearDrawingEmitter.emit();
		this.searchFormGroup.reset();
		this.completeDateStart = null;
		this.completeDateEnd = null;
		this.reportDateStart = null;
		this.reportDateEnd = null;
		this.reportDatesValid = true;
		this.completeDatesValid = true;
		this.searchFormPopulated = false;

		this.clearSaveSearchFields();
	}

	openModal(modal: TemplateRef<any>) {
		this.modal = this.modalService.open(modal, { backdrop: 'static' });
	}

	closeModal() {
		if (this.modal) {
			this.modal.close();
		}
	}

	openSaveSearchPrompt() {
		this.openModal(this.saveSearchModal);
	}

	closeSaveSearch() {
		this.clearSaveSearchFields();
		this.closeModal();
	}

	clearSaveSearchFields() {
		// (<HTMLInputElement>document.getElementById('saveSearchNameInput')).value = '';
		this.saveSearchForm.get('saveSearchName').reset();
		this.saveSearchName = '';
	}

	updateSaveName() {
		// this.saveSearchName = (<HTMLInputElement>document.getElementById('saveSearchNameInput')).value;
		this.saveSearchName = this.saveSearchForm.get('saveSearchName').value;
	}

	saveSearchParameters() {
		const searchParams = this.createSearchParams();
		const savedSearchQuery: SaveSearchQueryPayload = Object.assign({}, searchParams, {
			savedQueryName: this.saveSearchName,
			polygon: searchParams.polygon.toString(),
		});
		this.closeSaveSearch();
		this.saveSearchEmitter.emit(savedSearchQuery);
	}

	onDateSelection(date: NgbDate, source: string) {
		switch (source) {
			case 'reportDateStart':
				this.reportDateStart = date;
				break;
			case 'reportDateEnd':
				this.reportDateEnd = date;
				break;
			case 'completeDateStart':
				this.completeDateStart = date;
				break;
			case 'completeDateEnd':
				this.completeDateEnd = date;
				break;
			default:
				break;
		}

		if (source.indexOf('report') > -1) {
			if (this.reportDateEnd && this.reportDateStart) {
				this.reportDatesValid = this.reportDateEnd.after(this.reportDateStart) || this.reportDateEnd.equals(this.reportDateStart);
			}
		} else {
			if (this.completeDateEnd && this.completeDateStart) {
				this.completeDatesValid = this.completeDateEnd.after(this.completeDateStart) || this.completeDateEnd.equals(this.completeDateStart);
			}
		}
	}

	onMapUpdate(action: any) {
		if (action.type) {
			this.mapUpdateEmitter.emit(action);
		} else if (action.length == 1) {
			this.mapUpdateEmitter.emit(action);
		}
		else {
			action.forEach((act: DnvMapAction) => {
				this.mapUpdateEmitter.emit(act);
			})
		}

	}

	onMoveChange(state: DnvMapState) {
		this.mapMoveEmitter.emit(state);
	}

	onZoomChange(state: DnvMapState) {
		this.mapZoomEmitter.emit(state);
	}

	toggleMap() {
		this.mapShow = !this.mapShow;

		// CHANGE THE NAME OF THE BUTTON.
		if (this.mapShow) {
			this.buttonName = 'Hide';
			this.setPinEmitter.emit();
		} else {
			this.buttonName = 'Show';
			this.clearDrawingEmitter.emit();
		}
	}

	clearDrawing() {
		this.clearDrawingEmitter.emit();
	}

	startDrawing() {
		this.startDrawingEmitter.emit();
	}

	checkNotEmptyOrZero(params: SearchResultsPayload) {
		for (const p in params) {
			if ((params as any)[p] !== '' && (params as any)[p] !== '0' && p !== 'polygon') {
				return true;
			} else if (this.mapState.features && this.mapState.features[0]) {
				if (this.mapState.features[0].geometry) {
					return true;
				}
			}
		}
		return false;
	}
}
